import {ChangeDetectionStrategy, Component} from '@angular/core';
import {TranslatePipe} from '@brunata-angular/util';
import {BrunataOnlineLogoComponentComponent} from '@shared/brunata-online-logo-component/brunata-online-logo-component.component';

@Component({
    selector: 'app-maintenance',
    standalone: true,
    template: ` <div class="container">
        <div class="text-center m-5">
            <app-brunata-online-logo-component></app-brunata-online-logo-component>
        </div>
        <div class="card">
            <div class="card-body m-5 fs-5">
                {{ 'maintenance_2024-05-24' | translate }}
            </div>
        </div>
    </div>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslatePipe, BrunataOnlineLogoComponentComponent],
})
export class MaintenanceComponent {}
